'use strict';

var backInStock = require('./product/backInStock');

function initRecommendations() {
	var giftAmount = $('input#gifted-amount-value').val();
	var gifterName = $('input#gifted-sender-name-value').val();

	var recommSlotNodes = document.querySelectorAll('.gifted-product-recommendations-slot [id^="cq_recomm_slot"]');
	var observer = new MutationObserver(function (MutationRecord) {
		MutationRecord.forEach(function (m) {
			var $target = $(m.target);
			if ($target.hasClass('gifted-inited')) {
				return;
			}
			$target.addClass('gifted-inited');

			var $slotHeader = $target.find('.slot-title');
			var slotHeaderHtml = $slotHeader.html();
			slotHeaderHtml = slotHeaderHtml.replace(/\[gift-amount\]/g, giftAmount);
			slotHeaderHtml = slotHeaderHtml.replace(/\[gifter-name\]/g, gifterName);
			$slotHeader.html(slotHeaderHtml);
			$target.closest('.gifted-product-recommendations-slot').find('.gifted-recommendations-button').show();
		});
	});
	if (recommSlotNodes) {
		for (var i = 0; i < recommSlotNodes.length; i++) {
			observer.observe(recommSlotNodes[i], {attributes: true, childList: true});
		}
	}
}

/**
 * This was added in scope of HCGBS-36
 * Animating Gift By SMS section
 */
function animateMessages() {
	var $topMessages = $('.pt_gifted-product .gift-msg .gift-msg-section'),
		$infoBlock = $('.gifted-product, .gifted-instructions');
	$topMessages.each(function (i, el) {
		setTimeout(function () {
			$(el).animate({opacity: 1}, 400);
			if (i === 3) {
				setTimeout(function () {
					$infoBlock.animate({opacity: 1}, 500);
				}, 1000);
			}
		}, i * 1000);
	});
}

function initBackInStock() {
	var $backInStockBtn = $('.back-in-stock-notification');
	if ($backInStockBtn.length > 0) {
		var backInStockURL = $('input#back-in-stock-url').val();
		$backInStockBtn.attr('href', backInStockURL);
		backInStock();
	}
}

function initAvailabilityDateCheck() {
	var inStockDateText = $('#instockdate').val();
	if (inStockDateText !== 'null') {
		$('#availability-message').text(inStockDateText);
	}
}

var giftedproduct = {
	init: function () {
		animateMessages();
		initBackInStock();
		initRecommendations();
		initAvailabilityDateCheck();
	}
};

module.exports = giftedproduct;
